
export const LocalStorageKeys = {
  lang:"lang",
  themeMode:"themeMode",
  dir:"dir",
  activeOrganizationId:"activeOrganizationId",
  accessToken:"act",
  refreshToken:"rft",
  isUseSeparator:"isUseSeparator"
}
